import { render, staticRenderFns } from "./add-edit-multi-econsent-quiz.vue?vue&type=template&id=47921648&scoped=true&"
import script from "./add-edit-multi-econsent-quiz.vue?vue&type=script&lang=js&"
export * from "./add-edit-multi-econsent-quiz.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-multi-econsent-quiz.vue?vue&type=style&index=0&id=47921648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47921648",
  null
  
)

component.options.__file = "add-edit-multi-econsent-quiz.vue"
export default component.exports